// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__sLiVu","logo":"footer_logo__25Xlv"};